/* tslint:disable */
import { randomNumber } from '@support/shared/services/random-number.helper';
export const Base64URL = {
  stringify: function (a) {
    const base64string = btoa(String.fromCharCode.apply(0, a));
    return base64string.replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_');
  },
  parse: function (s) {
    s = s.replace(/-/g, '+').replace(/_/g, '/').replace(/\s/g, '');
    return new Uint8Array(
      Array.prototype.map.call(atob(s), function (c) {
        return c.charCodeAt(0);
      })
    );
  },
};

export function utf8ToUint8Array(str, btoa: (s: string) => string) {
  str = btoa(unescape(encodeURIComponent(str)));
  return Base64URL.parse(str);
}

export function uint8ArrayToUtf8(buf): string {
  return String.fromCharCode.apply(null, new Uint8Array(buf));
}

export function bytesToHexString(bytes): string {
  if (!bytes) return '';

  bytes = new Uint8Array(bytes);

  const hexBytes = [] as string[];

  for (let i = 0; i < bytes.length; ++i) {
    let byteString: string = bytes[i].toString(16);
    if (byteString.length < 2) byteString = '0' + byteString;
    hexBytes.push(byteString);
  }

  return hexBytes.join('');
}

export function createGUID(): string {
  function randomStr() {
    return Math.floor((1 + randomNumber()) * 0x10000)
      .toString(16)
      .substring(1);
  }
  return (
    randomStr() +
    randomStr() +
    '-' +
    randomStr() +
    '-' +
    randomStr() +
    '-' +
    randomStr() +
    '-' +
    randomStr() +
    randomStr() +
    randomStr()
  );
}
